import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { actions } from '../../TransfersState'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import * as S from './CageDetails.styles'
import { Typography } from '@mui/material'
import { capitalizeString } from 'src/utils/capitalize'
import { CageDetailsItemCard } from '../../components/CageDetailsItemCard/CageDetailsItemCard'

interface Params {
  idCage: string
}

export const CageDetails = () => {
  const { idCage } = useParams<Params>()

  const dispatch = useDispatch()
  const { transferCageDetails } = useSelector((state) => state.transfers)

  useEffect(() => {
    if (idCage) {
      dispatch(actions.getCageDetails(Number(idCage)))
    }
  }, [dispatch, idCage])

  const goBack = () => {
    window.history.back()
  }

  return (
    <S.Wrapper>
      <S.CustomButton
        title='Voltar'
        type='button'
        bgColor='blue'
        hoverColor='darkBlueHover'
        letterColor='white'
        onClick={goBack}
        data-testid='back-button-test-id'
      />
      <Typography variant='h5' fontWeight='bold' sx={{ alignSelf: 'center' }}>Detalhes de Gaiola de Transferência</Typography>
      {transferCageDetails
      && (
        <>
          <S.GridCageUserInfo>
            <S.CustomTextField
              name='startedBy'
              id='startedBy'
              label='Iniciada por'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-started-by-test-id',
              }}
              value={transferCageDetails.createdBy}
            />
            <S.CustomTextField
              name='startedAt'
              id='startedAt'
              label='Iniciada em'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-started-at-test-id',
              }}
              value={transferCageDetails.createdAt}
            />
            <S.CustomTextField
              name='updatedBy'
              id='updatedBy'
              label='Atualizada por'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-updated-by-test-id',
              }}
              value={transferCageDetails.updatedBy || '-'}
            />
            <S.CustomTextField
              name='updatedAt'
              id='updatedAt'
              label='Atualizada em'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-updated-at-test-id',
              }}
              value={transferCageDetails.updatedAt || '-'}
            />
          </S.GridCageUserInfo>
          <S.GridCageInfo>
            <S.CustomTextField
              name='address'
              id='address'
              label='Endereço'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-address-test-id',
              }}
              value={transferCageDetails.address}
            />
            <S.CustomTextField
              name='sourceFc'
              id='sourceFc'
              label='FC de Origem'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-source-fc-test-id',
              }}
              value={transferCageDetails.sourceFc}
            />
            <S.CustomTextField
              name='destinationFc'
              id='destinationFc'
              label='FC de Destino'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-destination-fc-test-id',
              }}
              value={transferCageDetails.destinationFc}
            />
            <S.CustomTextField
              name='status'
              id='status'
              label='Status'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-status-test-id',
              }}
              value={capitalizeString(transferCageDetails.status)}
            />
          </S.GridCageInfo>
          <S.GridCageNFeInfo>
            <S.CustomTextField
              name='orderCode'
              id='orderCode'
              label='Código do Pedido'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-order-code-test-id',
              }}
              value={transferCageDetails.orderCode || '-'}
            />
            <S.CustomTextField
              name='nfeStatus'
              id='nfeStatus'
              label='Status da NFe'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-nfe-status-test-id',
              }}
              value={transferCageDetails.nfeStatus ? capitalizeString(transferCageDetails.nfeStatus) : '-'}
            />
            <S.CustomTextField
              name='invoiceAccessKey'
              id='invoiceAccessKey'
              label='Chave de Acesso da NFe'
              type='text'
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                'data-testid': 'cage-invoice-access-key-test-id',
              }}
              value={transferCageDetails.invoiceAccessKey || '-'}
            />
          </S.GridCageNFeInfo>
          {transferCageDetails?.items.map((item) => (
            <CageDetailsItemCard
              key={item.idModel}
              sourceFc={transferCageDetails.sourceFc}
              destinationFc={transferCageDetails.destinationFc}
              item={item}
            />
          ))}
        </>
      )}
    </S.Wrapper>
  )
}
